<template>
  <div class="inspectionDetail">
    <pageTitle class="getHeader" :title="title" :corner="corner" @cornerAdd="toPrint"></pageTitle>
    <div class="proBox" v-if="title == '巡查预览'">
      <h3 class="line-title">{{ pageTitle }}</h3>
      <div class="info">
        <span class="t1">被检单位：</span>
        <span>{{ entName || storeName }}</span>
      </div>
      <div class="info">
        <span class="t1">被检日期：</span>
        <span>{{ patrolTime }}</span>
      </div>
      <div class="info">
        <span class="t1">所属区域：</span>
        <span>{{ areaPath }}</span>
      </div>
      <div class="info">
        <span class="t1">检查单位：</span>
        <span>{{ regName }}</span>
      </div>
      <div class="info">
        <span class="t1">检查人员：</span>
        <span>{{ regWorkerText }}</span>
      </div>
      <h3 class="line-title">
        <span class="t1">检查内容</span>
        <span>结果</span>
      </h3>
      <!-- 动态选项 -->
      <div class="bag bags">
        <div v-for="(v, i) in patrolList" :key="'patrolList_' + i">
          <p :class="[v.valType === -1 ? 'isTitle' : '']">
            <span class="span1">{{ v.itemNo }}. {{ v.itemDesc }}</span>
            <span class="span2">{{ detailDtos[i].text || '' }}</span>
          </p>
        </div>
      </div>
      <div class="info">
        <span class="t1">检查记录：</span>
        <span>{{ contents }}</span>
      </div>
      <div class="info">
        <span class="t1">检查结果：</span>
        <span class="greenText">{{ resultText }}</span>
      </div>
      <div class="info" v-if="signature">
        <span class="t1">签名：</span>
        <img :src="signature" />
      </div>
    </div>
    <div class="proBox" v-else>
      <h3 class="line-title">{{ pageTitle }}</h3>
      <div class="info">
        <span class="t1">被抽样单位：</span>
        <span>{{ obj.entName }}</span>
      </div>
      <div class="info">
        <span class="t1">抽样日期：</span>
        <span>{{ obj.createTime }}</span>
      </div>
      <div class="info">
        <span class="t1">所属地区：</span>
        <span>{{ obj.areaPath }}</span>
      </div>
      <div class="info">
        <span class="t1">查样单位：</span>
        <span>{{ obj.checkOrgName }}</span>
      </div>
      <div class="info">
        <span class="t1">查样人员：</span>
        <span>{{ obj.persons }}</span>
      </div>
      <div class="info">
        <span class="t1">检测类型：</span>
        <span>{{ obj.checkType == 2 ? '机构代检' : '第三方检测' }}</span>
      </div>
      <div class="bag topBags" v-for="(v, i) in obj.details" :key="'details' + i">
        <div>{{ i + 1 }}号样品<span style="margin-left:1rem;">样品编号{{ v.sampleNo }}</span></div>
        <div> 样品名称：{{ v.productName }}</div>
        <div> 检测方式：{{ v.checkWayName }}</div>
        <div> 样品基数：{{ v.sampleCardinal }}</div>
        <div> 样品来源：{{ v.sampleSource }}</div>
      </div>
    </div>
  </div>
</template>


<script>
import { getOnePatrolForEdit } from '@/api/inspection'
import { getOneSamplingTask } from '@/api/sampling';

export default {
  name: 'inspectionView',
  components: {
  },
  data() {
    return {
      title: '',
      pageTitle: '农产品质量安全现场检查单',
      corner: '打印',
      patrolId: '',
      areaPath: '',
      entName: '',
      entId: '',
      storeName: '',
      resultText: '',
      regId: '',
      regName: '',
      contents: '',
      patrolTime: '',
      regWorker: [{}],
      regWorkerText: '',
      patrolObjTypeText: '',
      gpsAddress: '',
      lng: '',
      lat: '',
      patrolList: [],
      detailDtos: [],
      patrolObjType: '',
      showBtn: true,
      signature: '',
      obj: {}
    }
  },
  created() {
    // 获取详情
    this.title = this.$route.query.name + '预览';//采样与巡查判断
    this.title == '采样预览' ? this.pageTitle = '农产品质量安全现场采样单' : this.pageTitle = '农产品质量安全现场检查单';
    if (this.title == '采样预览') {
      // this. = JSON.parse(this.$route.query.obj);
      this.togetOneSamplingTask(this.$route.query.id)
    } else {
      const patrolId = this.$route.query.patrolId || '';
      this.showBtn = this.$route.query.showBtn == true;
      this.patrolId = patrolId
      if (patrolId) {
        this.toGetOnePatrolForEdit()
      }
    }

  },
  mounted() {
    if(this.title == '采样预览'){
      window.patrolPrintSup = this.pressPrint;//给安卓的方法->采样数据
    }else{
      window.printSupervision = this.pressPrint;
    }
   
  },
  methods: {
    togetOneSamplingTask(id) {
      getOneSamplingTask({ samplingTaskId: id }).then(res => {
        if (res.state == 'Y') {
          this.obj = res.data;
        } else {
          this.$toast(res.msg)
        }
      })
    },
    formatterData() {
      if (this.title == '采样预览') {
        let details = [];
        this.obj.details.forEach(item => {
          details.push({
            sampleNo: item.sampleNo,//编号
            productName: item.productName,//样品名称
            checkWayName: item.checkWayName,//检测方式
            sampleCardinal: item.sampleCardinal,//样品基数
            sampleSource: item.sampleSource//样品来源
          })
        })
        return {
          entName: this.obj.entName,// 被抽样单位
          createTime: this.obj.createTime,//抽样日期
          areaPath: this.obj.areaPath,//所属地区
          checkOrgName: this.obj.checkOrgName,//查样单位
          persons: this.obj.persons,//查样人员
          checkType: this.obj.checkType,//检测类型
          details: details
        }
      } else {
        // 巡查
        return {
          patrolId: this.patrolId,  // id
          title: this.pageTitle,    // 标题
          areaPath: this.areaPath,  // 所属地区
          storeName: this.storeName, // 农资店名称 - 有就显示
          entName: this.entName, // 企业名称 - 有就显示
          patrolObjType: this.patrolObjTypeText, // 巡查对象
          patrolTime: this.patrolTime, // 时间
          gpsAddress: this.gpsAddress, // 定位地址
          lng: this.lng, // 经度
          lat: this.lat, // 维度
          regName: this.regName, // 检查单位
          regWorker: this.regWorkerText, // 监管人员
          result: this.resultText, // 巡查结果
          contents: this.contents, // 记录内容
          patrolList: this.patrolList, // 检查内容
          detailDtos: this.detailDtos, // 检查内容 - 带中文
          signature: this.signature, // 签名
        }
      }
    },
    toPrint() { // 打印
      let paramsJson = this.formatterData();
      let u = navigator.userAgent
      if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        /* eslint-disable no-undef */
        window.webkit.messageHandlers.patrolPrint.postMessage(paramsJson)
      } else if (u.indexOf('Android') > -1 || u.indexOf('Adr') > -1) {
        if (this.title == '采样预览') {
          method && method.samplePrint(JSON.stringify(paramsJson))
        } else {
          method && method.patrolPrint(JSON.stringify(paramsJson))
        }
        /* eslint-disable no-undef */
      } else {
        // 不在 移动端
      }
    },
    pressPrint() { // 设备 - 按打印按钮
      let paramsJson = this.formatterData();
      return paramsJson;
    },
    toGetOnePatrolForEdit() { // 获取一个生产信息的详情
      getOnePatrolForEdit({
        patrolId: this.patrolId,
      }).then(res => {
        if (res.state === 'Y') {
          this.contents = res.data.contents
          this.patrolTime = res.data.patrolTime
          this.areaPath = res.data.areaPath
          this.entId = res.data.entId
          this.entName = res.data.entName
          this.regId = res.data.regId
          this.regName = res.data.regName
          this.resultText = res.data.result === 1 ? '合格' : res.data.result === 2 ? '基本合格' : '不合格'
          this.regWorkerText = res.data.workers.map(s => s.workerName).join(',')
          this.lng = res.data.lng
          this.lat = res.data.lat
          this.gpsAddress = res.data.gpsAddress
          this.signature = res.data.signature


          // if (res.data.image1) {
          //   this.imgUpList.push({ src: res.data.image1 })
          // }
          // if (res.data.image2) {
          //   this.imgUpList.push({ src: res.data.image2 })
          // }
          // if (res.data.image3) {
          //   this.imgUpList.push({ src: res.data.image3 })
          // }

          let arr = []
          let obj = {}
          this.patrolObjType = res.data.patrolObjType;
          if (res.data.patrolObjType === 1 || res.data.patrolObjType === 3 || res.data.patrolObjType === 4) {
            this.entName = res.data.patrolObjName;
          } else if (res.data.patrolObjType === 2) {
            this.storeName = res.data.patrolObjName;
          }
          this.patrolObjTypeText = res.data.patrolObjType === 1 ? '生产基地' : res.data.patrolObjType === 2 ? '农资店' : res.data.patrolObjType === 4 ? '水产基地' : '畜禽养殖基地'

          res.data.items.forEach((v, i) => {
            arr.push({ itemNo: v.itemNo, itemDesc: v.itemDesc, patrolSchemeItemCode: v.patrolSchemeItemCode, valDicResult: v.valDicResult, valType: v.valType, patrolItemId: v.patrolItemId })
            if (v.childs.length === 0) {
              let text = ''
              let n = v.valDicResult
              if (v.valType === 0) {
              } else if (v.valType === 1) {
                text = n === 1 ? '合格' : n === 2 ? '基本合格' : '不合格'
              } else if (v.valType === 2) {
                text = n === 1 ? '是' : '否'
              } else if (v.valType === 3) {
                text = n === 1 ? '有' : '无'
              }
              this.detailDtos.push({ upText: 'valDicResult', text: text, value: n, code: v.patrolSchemeItemCode, patrolItemId: v.patrolItemId })
            } else {
              v.childs.forEach((r, k) => {
                arr.push(r)
                let text = ''
                let n = r.valDicResult
                if (r.valType === 0) {
                } else if (r.valType === 1) {
                  text = n === 1 ? '合格' : n === 2 ? '基本合格' : '不合格'
                } else if (r.valType === 2) {
                  text = n === 1 ? '是' : '否'
                } else if (r.valType === 3) {
                  text = n === 1 ? '有' : '无'
                }
                obj = { upText: 'valDicResult', text: text, value: n, code: r.patrolSchemeItemCode, patrolItemId: r.patrolItemId }
                // 传父级
                if (k === 0) {
                  this.detailDtos.push({ value: v.valDicResult, code: v.patrolSchemeItemCode, patrolItemId: v.patrolItemId })
                }
                this.detailDtos.push(obj)
                text = null
                n = null
              })
            }
          })
          this.patrolList = arr

        } else {
          this.$alertErr(res.msg)
        }
      }).catch(err => {
        this.$alertErr(err || '网络错误，请稍后再试！')
      })
    },
  },
  watch: {
  },
}
</script>

<style lang="stylus" scoped>
.inspectionDetail {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;

  & > .proBox {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 4vmin;
    color: #333;
  }

  .line-title {
    font-weight: bold;
    margin: 5vmin 0;
    line-height: 20vmin;
    border-top: 2px dashed #333;
    border-bottom: 2px dashed #333;
    text-align: center;
    display: flex;
    justify-content: center;
    font-size: 5vmin;

    span {
      flex: 1;
      font-weight: bold;
    }
  }

  .info {
    display: flex;
    line-height: 8vmin;
    flex-wrap: wrap;
    margin-bottom: 2vmin;

    span {
      display: inline-block;
      font-size: 4vmin;
    }

    .greenText {
      color: #2AB774;
      font-weight: 600;
    }

    img {
      width: 40vmin;
    }
  }
}
.topBags{
  border-top: 2px dashed #333;
  padding-top: 3vmin;
  margin-top: 5vmin;
}
.bags {
  border-bottom: 2px dashed #333;
  padding-bottom: 3vmin;
  margin-bottom: 5vmin;

  p {
    display: block;
    min-height: 90px;
    padding: 2vmin 0;
    box-sizing: border-box;
    font-size: 4vmin;

    &.isTitle {
      min-height: 40px;
    }

    .span1 {
      display: block;
      text-align: left;
      text-indent: 0;
      word-break: break-all;
      word-wrap: break-word;
      white-space: normal;
      line-height: 8vmin;
      box-sizing: border-box;
    }

    .span2 {
      display: block;
      text-align: right;
      text-indent: 0;
      line-height: 8vmin;
      font-weight: bold;
    }
  }
}
</style>
